import ImgTag from "@/components/Helpers/ImgTag";
import browserStorage from "store";

const BannerSection = ({ locale }) => {
  const banner = browserStorage.get("popup-banner")
    ? browserStorage.get("popup-banner")[`img-${locale}`]
    : "";

  return banner ? (
    <ImgTag
      src={banner}
      className="object-contain w-full h-auto px-4 mb-10"
      height={92}
      width={560}
      alt="Tamara Sheet Img!"
    />
  ) : (
    ""
  );
};

export default BannerSection;
